import React, { useEffect } from "react";

const MentionsLegales: React.FC = () => {
  const title = "Mentions légales | Mon Copieur";
  const description = "Mentions légales de Mon Copieur.";
  
  useEffect(() => {
    document.title = title;
    let metaTag = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.name = "description";
      document.head.appendChild(metaTag);
    }
    metaTag.content = description;
  }, []);
  
  return (
    <>
      <header className="border-b border-border bg-secondary/40">
        <div className="container mx-auto px-4 py-10">
          <h1 className="text-3xl font-semibold">Mentions légales</h1>
        </div>
      </header>

      <article className="prose prose-neutral max-w-none container mx-auto px-4 py-8">
        <ul>
          <li>Éditeur du site : MON COPIEUR</li>
          <li>Siège social : 194 Bd Ba Hmad, Casablanca 20300</li>
          <li>Téléphone : +212 522 401708</li>
          <li>E-mail : contact@moncopieur.ma</li>
          <li>ICE : 003625896000095</li>
          <li>RC : 654229</li>
          <li>Identifiant fiscal : 66159799</li>
          <li>RIB : 022780000117002910260974</li>
          <li>Directeur de la publication : Yassine CHOUGDALI</li>
          <li>Hébergeur du site : NETCODE</li>
        </ul>
      </article>
    </>
  );
};

export default MentionsLegales;